export const coFlag = () => {
    return (
        <svg width={"100%"} height={"100%"} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 6 4">
            <rect fill="#CE1126" width="6" height="4" />
            <rect fill="#003893" width="6" height="3" />
            <rect fill="#FCD116" width="6" height="2" />
        </svg>
    );
};
